// Hero section component file
import React, { useEffect, useState } from "react";
import '../../styles/homepage/HeroSection.css'

function HeroSection (){
    const [currentIndex, setCurrentIndex] = useState(0);

    const images = [
        '/images/african-man-woman-cleaning-2.webp',
        '/images/kindagigz-mobile.webp',
        '/images/business-woman-on-call.webp',
        '/images/kindatrade-mobile.webp',
        '/images/man-viewing-platform.webp'
    ];

    // Setting the slideshow to happen every 3 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [images.length]);

    return (
        // Hero section content
        <div 
            className="hero-section-component"
            style={{ backgroundImage: `url(${images[currentIndex]})` }}
        >
            <div className="hero-section">
                <h1>Enhancing Employment and Trade through <span>Kinda Digital</span> Solutions.</h1>
                <h3>Get Connected | Enhance Efficiency | Improve your <span>Business Acumen</span></h3>
            </div>
        </div>
    )
};

export default HeroSection;
